<template lang='pug'>
//- 首頁
div(:class='$style[`cc-index-container`]')
  section(:class='$style[`cc-index-kv`]')
    div(:class='$style[`cc-kv-wrap`]')
      div(:class='$style[`cc-kv-wrap-left`]')
        div(:class='$style[`cc-kv-wrap-left-block`]')
          figure(:class='$style[`cc-kv-wrap-left-logo`]')
          header(:class='$style[`cc-kv-wrap-left-title`]')
            span.font-bold 醫療
            span.font-bold.font-doctor-theme AI助手
            span.font-bold 輔助抗癌、極簡單
            //- span.font-bold 讓病患
            //- span.font-bold.font-doctor-theme 求助AI
            //- span.font-bold 1u042

          div(:class='$style[`cc-kv-wrap-left-controller`]')
            button.btn-extra(
              tabindex='0'
              aria-label='開始使用'
              :class='$style[`cc-kv-wrap-left-controller-startup`]'
              @click='handleClickLogin') 👉 開始使用

      div(:class='$style[`cc-kv-wrap-right`]')
        figure(:class='$style[`cc-kv-wrap-right-banner`]')



  //- ePRO系統
  section(:class='$style[`cc-index-epro`]')
    div(:class='$style[`cc-epro-wrap`]')
      div(:class='$style[`cc-epro-wrap-left`]')
        div(:class='$style[`cc-epro-wrap-left-block`]')
          header(:class='$style[`cc-epro-wrap-left-title`]')
            span.font-bold 採用
            span.font-bold.font-doctor-theme ePRO系統
            span.font-bold 親述您的症狀

          div(:class='$style[`cc-epro-wrap-left-info`]')
            span ePRO（Electronic Patient-Reported Outcomes）是指透過電子方式收集的患者報告結果。這種方法使患者能夠直接報告他們在健康狀況、疾病、治療或醫療服務方面的感受和經歷，而不是通過醫療專業人員的解釋或評估。ePRO系統通常用於臨床試驗和日常醫療管理中，以收集有關症狀、生活質量和治療效果等方面的資料。
          div(:class='$style[`cc-epro-wrap-left-origin`]')
            a(
              tabindex='0' aria-label='「美國ASCO報告」透過ePRO工具改善癌症患者生活品質。'
              href='https://www.obroncology.com/article/new-data-show-patient-reported-outcomes-may-improve-quality-of-life-symptoms-in-cancer'
              title='「美國ASCO報告」透過ePRO工具改善癌症患者生活品質') 
              IconSearch(:size='18' :color='`#262626`')
              span 「美國ASCO報告」ePRO改善患者生活品質

            a(
              tabindex='0' aria-label='「美國頂尖JAMA期刊」研究報告'
              href='https://pubmed.ncbi.nlm.nih.gov/28586821/'
              title='「美國頂尖JAMA期刊」研究報告')
              IconSearch(:size='18' :color='`#262626`')
              span 「美國頂尖JAMA期刊」ePRO提升癌症存活率

      div(:class='$style[`cc-epro-wrap-right`]')
        figure(:class='$style[`cc-epro-wrap-right-banner`]')



  //- VIP會員
  section(:class='$style[`cc-index-vip`]')
    div(:class='$style[`cc-vip-wrap`]')
      div(:class='$style[`cc-vip-wrap-top`]')
        div(:class='$style[`cc-vip-wrap-top-block`]')
          header(:class='$style[`cc-vip-wrap-top-title`]')
            span.font-bold(style='display: block')
              span 訂閱
              span.border-gradient(:class='$style[`cc-vip-mark`]') VIP會員
            span.font-bold(style='display: block') 暢用所有服務

          div(:class='$style[`cc-vip-wrap-top-panel`]')
            router-link(
              tabindex='0' aria-label='了解訂閱方案'
              to='/shop/subscribe'
              title='了解方案內容'
              :class='$style[`cc-vip-wrap-top-link`]')
              IconSearch(:size='18' :color='`#fff`')
              span 了解方案內容

            div(:class='$style[`cc-vip-wrap-top-info`]') * 免費試用 14 天，且不會自動續訂。
            div(:class='$style[`cc-vip-wrap-top-info`]') * VIP方案 包含遠距照護服務、學習抗癌衛教。

      div(:class='$style[`cc-vip-wrap-bottom`]')
        div(:class='$style[`cc-demo-wrap-grid1`]')
          span.font-medium 癌症營養設計
        div(:class='$style[`cc-demo-wrap-grid2`]')
          span.font-medium 癌症遠距照護
        div(:class='$style[`cc-demo-wrap-grid3`]')
          span.font-medium 抗癌衛教內容
        div(:class='$style[`cc-demo-wrap-grid4`]')
          header.font-medium(:class='$style[`cc-demo-wrap-security-head`]') 「Cancell 醫抗癌」採用最高等級的資安認證與標準

          ul(:class='$style[`cc-demo-wrap-security-ul`]')
            //- li(:class='$style[`cc-demo-wrap-security-li`]')
            //-   figure(:class='$style[`cc-demo-wrap-security-aws`]')
            li(:class='$style[`cc-demo-wrap-security-li`]')
              figure(:class='$style[`cc-demo-wrap-security-iso27001`]')
            li(:class='$style[`cc-demo-wrap-security-li`]')
              figure(:class='$style[`cc-demo-wrap-security-iso27701`]')
            li(:class='$style[`cc-demo-wrap-security-li`]')
              figure(:class='$style[`cc-demo-wrap-security-iso27717`]')
            li(:class='$style[`cc-demo-wrap-security-li`]')
              figure(:class='$style[`cc-demo-wrap-security-csa`]')




  //- Dr.Cell AI
  section(:class='$style[`cc-index-drcell`]')
    div(:class='$style[`cc-drcell-wrap`]')
      div(:class='$style[`cc-drcell-wrap-top`]')
        div(:class='$style[`cc-drcell-wrap-top-block`]')
          header(:class='$style[`cc-drcell-wrap-top-title`]')
            span.font-bold(style='display: block') 讓AI成為神助手
            div(:class='$style[`cc-drcell-wrap-top-info`]') Dr.Cell AI 為 Cancell醫抗癌 所推出的癌症副作用LLM模型，作為醫病遠距照護的強大輔助工具。僅需動動指尖即可請求Dr.Cell幫忙，讓病患使用AI變得極簡單。
          div(:class='$style[`cc-drcell-wrap-top-panel`]')
            figure(:class='$style[`cc-drcell-wrap-top-logo`]')



  //- 功能預覽
  section(:class='$style[`cc-index-demo`]')
    div.demo-animate(:class='$style[`cc-demo-wrap`]')
      div(:class='$style[`cc-demo-wrap-left`]')
        div.demo-model(:class='$style[`cc-demo-wrap-left-demo`]')
          div(:class='[$style[`cc-demo-wrap-demo-ai`], $style[showAiChip ? `cc-showed` : ``]]')
            div(:class='$style[`cc-demo-wrap-demo-chip`]')
              //- div.progress-energy(:class='$style[`cc-demo-wrap-demo-chip-progress`]')
              span.font-bold(:class='$style[`cc-demo-wrap-demo-chip-text1`]') AI
              span(:class='$style[`cc-demo-wrap-demo-chip-text2`]') Cancell Dr.Cell
            div(:class='$style[`cc-demo-wrap-demo-info`]')
              span Dr.Cell為 Cancell 所推出的LLM模型，持續使用醫抗癌，AI會更懂你。
            svg(id='chip-line' :class='$style[`cc-chip-line`]' viewBox='0 0 164 84')
              line.progress-line(
                :class='$style[`cc-chip-line-animate`]'
                style='stroke: #4cca81;'
                x1='7.2'
                y1='29.66'
                x2='157.2'
                y2='29.66')
              line(
                style='stroke: #262626;'
                x1='157.2'
                y1='44.91'
                x2='7.2'
                y2='44.91')
              line.progress-line(
                :class='$style[`cc-chip-line-animate`]'
                style='stroke: #2ebfc4'
                x1='157.2'
                y1='59.44'
                x2='7.2'
                y2='59.44')

          figure.model-phone(:class='$style[`cc-demo-wrap-demo-phone`]')
          figure(:class='[`screen-0`, $style[`cc-demo-wrap-demo-screen`], $style[`cc-demo-wrap-demo-s0`]]')
          figure(
            v-for='n in 8'
            :class='[`screen-${n}`, $style[`cc-demo-wrap-demo-screen`], $style[`cc-demo-wrap-demo-s${n}`], $style[demoIndex === n ? `cc-showed` : ``]]')

      div(:class='$style[`cc-demo-wrap-right`]')
        div(:class='$style[`cc-demo-wrap-right-block`]')
          div(:class='$style[`cc-demo-wrap-right-header`]')
            header(v-show='demoIndex === 0' :class='$style[`cc-demo-wrap-right-title`]')
              span.font-bold(style='display: block')
                span 使用
                span.font-doctor-theme LINE
                span 註冊
              span.font-bold(style='display: block') 一鍵秒登

            header(v-show='demoIndex === 1' :class='$style[`cc-demo-wrap-right-title`]')
              span.font-bold(style='display: block')
                span.font-doctor-theme 2分鐘
                span 寫記錄
              span.font-bold(style='display: block') 讓AI更懂你

            header(v-show='demoIndex === 2' :class='$style[`cc-demo-wrap-right-title`]')
              span.font-bold(style='display: block')
                span AI
                span.font-doctor-theme 健檢預測
              span.font-bold(style='display: block') 個人醫療管家

            header(v-show='demoIndex === 3' :class='$style[`cc-demo-wrap-right-title`]')
              span.font-bold(style='display: block')
                span.font-doctor-theme AI諮詢
                span 隨時問
              span.font-bold(style='display: block') 醫師再補充

            header(v-show='demoIndex === 4' :class='$style[`cc-demo-wrap-right-title`]')
              span.font-bold(style='display: block')
                span 比谷歌
                span.font-doctor-theme 更棒的
              span.font-bold(style='display: block') 翻譯功能

            header(v-show='demoIndex === 5' :class='$style[`cc-demo-wrap-right-title`]')
              span.font-bold(style='display: block')
                span 專為
                span.font-doctor-theme 醫護
                span 打造的
              span.font-bold(style='display: block') 管理後台

            header(v-show='demoIndex === 6' :class='$style[`cc-demo-wrap-right-title`]')
              span.font-bold(style='display: block')
                span.font-doctor-theme 抗癌課程
                span 懶人包
              span.font-bold(style='display: block') 邊聽邊學

            header(v-show='demoIndex === 7' :class='$style[`cc-demo-wrap-right-title`]')
              span.font-bold(style='display: block')
                span 癌友
                span.font-doctor-theme 問答
                span 收藏庫
              span.font-bold(style='display: block') 秒看解答

            header(v-show='demoIndex === 8' :class='$style[`cc-demo-wrap-right-title`]')
              span.font-bold(style='display: block')
                span 社群、講座、資源
              span.font-bold(style='display: block')
                span.font-doctor-theme 公益
                span 做回饋

            //- 手機版面
            div(
              v-swiper:upgradeSwiper='swiperOption'
              :class='$style[`cc-demo-wrap-right-feature-mobile`]'
              ref='mySwiper')
              div(:class='$style[`cc-demo-wrap-right-feature-tip`]') {{ mobileFeatureTip }}
              ul(:class='[`swiper-wrapper`, $style[`cc-demo-wrap-right-feature-ul`]]')
                li(:class='[`swiper-slide`, $style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 1 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽記錄副作用功能'
                    tabindex='0'
                    aria-label='瀏覽記錄副作用功能'
                    @click='debounceMobileSwitchDemo(1)') 記錄副作用

                li(:class='[`swiper-slide`, $style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 2 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽AI健檢預測功能'
                    tabindex='0'
                    aria-label='瀏覽AI健檢預測功能'
                    @click='debounceMobileSwitchDemo(2)') AI健檢預測

                li(:class='[`swiper-slide`, $style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 3 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽線上諮詢功能'
                    tabindex='0'
                    aria-label='瀏覽線上諮詢功能'
                    @click='debounceMobileSwitchDemo(3)') 線上諮詢

                li(:class='[`swiper-slide`, $style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 4 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽報告翻譯功能'
                    tabindex='0'
                    aria-label='瀏覽報告翻譯功能'
                    @click='debounceMobileSwitchDemo(4)') 報告翻譯

                li(:class='[`swiper-slide`, $style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 5 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽管理後台功能'
                    tabindex='0'
                    aria-label='瀏覽管理後台功能'
                    @click='debounceMobileSwitchDemo(5)') 管理後台

                li(:class='[`swiper-slide`, $style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 6 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽線上課程功能'
                    tabindex='0'
                    aria-label='瀏覽線上課程功能'
                    @click='debounceMobileSwitchDemo(6)') 線上課程

                li(:class='[`swiper-slide`, $style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 7 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽QA問答庫功能'
                    tabindex='0'
                    aria-label='瀏覽QA問答庫功能'
                    @click='debounceMobileSwitchDemo(7)') QA問答庫

                li(:class='[`swiper-slide`, $style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 8 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽公益講座、社群、資源服務'
                    tabindex='0'
                    aria-label='瀏覽公益講座、社群、資源服務'
                    @click='debounceMobileSwitchDemo(8)') 公益講座、社群、資源

            //- 非手機版面
            div(:class='$style[`cc-demo-wrap-right-feature`]')
              div(:class='$style[`cc-demo-wrap-right-feature-tip`]') 遠距照護功能
              ul(:class='$style[`cc-demo-wrap-right-feature-ul`]')
                li(:class='[$style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 1 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽記錄副作用功能'
                    tabindex='0'
                    aria-label='瀏覽記錄副作用功能'
                    @click='switchDemoFeature(1)') 記錄副作用

                li(:class='[$style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 2 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽AI健檢預測功能'
                    tabindex='0'
                    aria-label='瀏覽AI健檢預測功能'
                    @click='switchDemoFeature(2)') AI健檢預測

                li(:class='[$style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 3 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽線上諮詢功能'
                    tabindex='0'
                    aria-label='瀏覽線上諮詢功能'
                    @click='switchDemoFeature(3)') 線上諮詢

                li(:class='[$style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 4 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽報告翻譯功能'
                    tabindex='0'
                    aria-label='瀏覽報告翻譯功能'
                    @click='switchDemoFeature(4)') 報告翻譯

                li(:class='[$style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 5 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽管理後台功能'
                    tabindex='0'
                    aria-label='瀏覽管理後台功能'
                    @click='switchDemoFeature(5)') 管理後台

              div(:class='$style[`cc-demo-wrap-right-feature-tip`]') 抗癌衛教
              ul(:class='$style[`cc-demo-wrap-right-feature-ul`]')
                li(:class='[$style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 6 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽線上課程功能'
                    tabindex='0'
                    aria-label='瀏覽線上課程功能'
                    @click='switchDemoFeature(6)') 線上課程

                li(:class='[$style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 7 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽QA問答庫功能'
                    tabindex='0'
                    aria-label='瀏覽QA問答庫功能'
                    @click='switchDemoFeature(7)') QA問答庫

                li(:class='[$style[`cc-demo-wrap-right-feature-li`], $style[demoIndex === 8 ? `cc-selected` : ``]]')
                  button(
                    title='瀏覽公益講座、社群、資源服務'
                    tabindex='0'
                    aria-label='瀏覽公益講座、社群、資源服務'
                    @click='switchDemoFeature(8)') 公益講座、社群、資源



  //- RWD
  section(:class='$style[`cc-index-rwd`]')
    div(:class='$style[`cc-rwd-wrap`]')
      div(:class='$style[`cc-rwd-wrap-top`]')
        div(:class='$style[`cc-rwd-wrap-top-block`]')
          header(:class='$style[`cc-rwd-wrap-top-title`]')
            span.font-bold 瀏覽器
            span.font-bold.font-doctor-theme 隨開即用
          div(:class='$style[`cc-rwd-wrap-top-info`]')
            span 完美支持手機、平板、筆記型電腦，無須配戴穿戴裝置

      div(:class='$style[`cc-rwd-wrap-bottom`]')
        div(:class='$style[`cc-rwd-wrap-bottom-browser`]')
          figure(:class='$style[`cc-rwd-wrap-browser-photo`]')
        div(:class='$style[`cc-rwd-wrap-bottom-rwd`]')
          figure(:class='$style[`cc-rwd-wrap-rwd-photo`]')
        div(:class='$style[`cc-rwd-wrap-bottom-startup`]')
          button.btn-extra(
            tabindex='0'
            aria-label='開始使用'
            :class='$style[`cc-rwd-wrap-bottom-startup-btn`]'
            @click='handleClickLogin') 👉 開始使用

  

  //- section(:class='$style[`cc-index-news`]')
  //-   div(:class='$style[`cc-news-wrap`]')
  //-     div(:class='$style[`cc-news-wrap-title`]')
  //-       div(:class='$style[`cc-news-wrap-title-text`]')
  //-         span.font-bold 新聞媒體

  //-       div(:class='$style[`cc-news-wrap-controller`]')
  //-         div.btn-extra(
  //-           :class='[`swiper-button-prev`, $style[`cc-news-wrap-controll-btn`]]') ←
  //-         div.btn-extra(
  //-           :class='[`swiper-button-next`, $style[`cc-news-wrap-controll-btn`]]') →

  //-     div(v-swiper:upgradeSwiper='swiperOption' :class='$style[`cc-news-wrap-news`]')
  //-       ul(:class='[`swiper-wrapper`, $style[`cc-news-wrap-news-ul`]]')
  //-         li(v-for='items, index in newsList' :key='index' :class='[`swiper-slide`, $style[`cc-news-wrap-news-li`]]' :title='items.title')
  //-           a(
  //-             role='button' tabindex='0' :aria-label='items.title'
  //-             :href='items.url' :class='$style[`cc-news-news-content`]')
  //-             figure(:class='$style[`cc-news-news-thumb`]')
  //-               img(:src='`${STATIC_URL}images/common/index/${items.thumbSrc}`' width='100%')
  //-             div(:class='$style[`cc-news-news-origin`]') {{ items.origin }}
  //-             div.font-bold(:class='$style[`cc-news-news-title`]') {{ items.title }}
  //-             div(:class='$style[`cc-news-news-more`]') 了解更多

  //-       div(:class='[`swiper-pagination`, $style[`cc-news-wrap-news-pagination`]]')


  //- section(:class='$style[`cc-index-vendor`]')
  //-   div(:class='$style[`cc-vendor-wrap`]')
  //-     header(:class='$style[`cc-vendor-wrap-title`]')
  //-       div(:class='$style[`cc-vendor-wrap-title-text`]')
  //-         span.font-bold 合作夥伴

  //-     div(:class='$style[`cc-vendor-wrap-vendor`]')
  //-       ul(:class='$style[`cc-vendor-wrap-vendor-ul`]')
  //-         li(v-for='item, index in vendorList' :key='index' :class='$style[`cc-vendor-wrap-vendor-li`]')
  //-           div
  //-             figure(:class='$style[`cc-vendor-vendor-avatar`]')
  //-               img(
  //-                 width='100%'
  //-                 :src='`${STATIC_URL}images/index/vendor/${item.thumbSrc}`'
  //-                 :alt='item.vendor'
  //-                 :title='item.vendor')


  //- Sitemap
  section(:class='$style[`cc-index-information`]')
    div(:class='$style[`cc-information-wrap`]')
      div(:class='$style[`cc-information-wrap-bottom`]')
        div(:class='$style[`cc-information-wrap-bottom-left`]')
          header.font-bold 加入LINE癌症社群
          figure(:class='$style[`cc-information-wrap-bottom-avatar`]')
            img(:src='`${STATIC_URL}images/index/lineSocial.webp`' width='100%')
        div(:class='$style[`cc-information-wrap-bottom-right`]')
          header.font-bold 更多資訊

          ul(:class='$style[`cc-information-wrap-bottom-ul`]')
            li(:class='$style[`cc-information-wrap-bottom-li`]' title='媒體資源')
              router-link(
                tabindex='0'
                aria-label='關於我們'
                to='/about')
                span 關於我們

            li(:class='$style[`cc-information-wrap-bottom-li`]' title='合作提案')
              a(
                tabindex='0' aria-label='合作提案'
                href='https://docs.google.com/forms/d/e/1FAIpQLSehPm0mz-SOp6bWY9_iG77eHCgwToBcEWjdjm-LvmN7zMy3_Q/viewform?usp=sf_link')
                span 合作提案

            li(:class='$style[`cc-information-wrap-bottom-li`]' title='隱私政策')
              router-link(
                tabindex='0'
                aria-label='隱私政策'
                to='/privacy')
                span 隱私政策

            li(:class='$style[`cc-information-wrap-bottom-li`]' title='使用條款')
              router-link(
                tabindex='0'
                aria-label='使用條款'
                to='/termUsage')
                span 使用條款

          div(:class='$style[`cc-information-wrap-bottom-info`]') 「Cancell 醫抗癌」是健細胞科技股份有限公司（CANCELL TECH CO.,LTD.）旗下的SaaS遠距醫療照護軟體。
          div(:class='$style[`cc-information-wrap-bottom-info`]') 聯絡信箱: service@cancell.tw



</template>

<script>
// import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex';
import { directive } from 'vue-awesome-swiper';
import { debounce } from 'debounce';
// import { mixin as clickaway } from 'vue-clickaway';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

import IconSearch from '../icon/Search';
// import IconMail from '../icon/Mail';
// import IconFacebook from '../icon/Facebook';
// import IconLine from '../icon/Line';
import IconHome from '../icon/Home';
// import IconTips from '../icon/Tips';
// import IconYoutube from '../icon/Youtube';


export default {
  metaInfo() {
    return {
      title: '一起抗癌',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw',
      }],
      // {
      //   name: 'og:title',
      //   content: '',
      // }, {
      //   name: 'description',
      //   content: '',
      // }, {
      //   name: 'og:description',
      //   content: '',
      // }],
    };
  },

  directives: {
    swiper: directive,
  },

  components: {
    IconSearch,
    IconHome,
    // IconFacebook,
    // IconLine,
    // IconTips,
    // IconMail,
    // IconYoutube,
  },

  // mixins: [clickaway],

  data() {
    return {
      demoIndex: 0,
      showAiChip: false,
      strokeDashOffset: 0,
      mobileFeatureTip: '遠距照護功能',

      swiperOption: {
        spaceBetween: 5,
        threshold: 20,
        slidesPerView: 'auto',
        centeredSlides: true,
        // loop: false,
        // loopFillGroupWithBlank: true,
        edgeSwipeThreshold: 100,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
      },

      vendorList: [
        {
          vendor: '癌康網',
          thumbSrc: 'canrec.webp',
        },
        {
          vendor: '心安營養',
          thumbSrc: 'nutreat.webp',
        },
        {
          vendor: '米蔚健康專業團隊',
          thumbSrc: 'midway.webp',
        },
        {
          vendor: '精拓生技',
          thumbSrc: 'cancerfree.webp',
        },
        {
          vendor: '大醫生技',
          thumbSrc: 'greencome.webp',
        },
        
        {
          vendor: '芙姵爾生醫',
          thumbSrc: 'frepair.webp',
        },
        {
          vendor: 'JoiiUp 虹映科技',
          thumbSrc: 'joiiup.webp',
        },
        {
          vendor: 'FarHugs遠距抱抱',
          thumbSrc: 'farhugs.webp',
        },
        {
          vendor: '安生診所',
          thumbSrc: 'anderson.webp',
        },
        {
          vendor: '中華民國乳癌病友協會',
          thumbSrc: 'tbca.webp',
        },
      ],
    };
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.loginStatus && vm.loginEproActive && vm.loginProfile.user_type === 'normal') {
        vm.$router.replace({
          path: '/sideeffect/record',
        })
      }
    });
  },

  // created() {
  //   if (this.loginStatus && this.loginEproActive) {
  //     this.$router.replace({
  //       path: '/sideeffect/record',
  //     })
  //   }
  // },

  mounted() {
    this.scrollAnimation();
    // window.addEventListener('resize', () => {
    //   ScrollTrigger.refresh();
    // });
  },

  destroyed() {
    const triggers = ScrollTrigger.getAll();
    triggers.forEach((trigger) => {
      trigger.kill();
    });
    ScrollTrigger.clearMatchMedia();
    // window.removeEventListener('resize', () => {
    //   ScrollTrigger.refresh();
    // });
  },

  methods: {
    ...mapMutations({
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleClickLogin() {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
      } else {
        this.$router.push({
          path: '/sideeffect/record',
        })
      }
    },

    switchDemoFeature(index) {
      this.demoIndex = index;
    },

    switchDemoFeatureMobileMode(index) {
      this.demoIndex = index;
      this.$refs.mySwiper.swiper.slideTo(this.demoIndex - 1, 350, false);

      if (this.demoIndex > 1) {
        this.showAiChip = true;
      } else {
        this.showAiChip = false;
      }

      if (this.demoIndex >= 6) {
        this.mobileFeatureTip = '抗癌衛教';
      } else {
        this.mobileFeatureTip = '遠距照護功能';
      }
    },

    debounceMobileSwitchDemo: debounce(async function(e) {
      this.switchDemoFeatureMobileMode(e);
    }, 300),

    scrollAnimation() {
      ScrollTrigger.matchMedia({
        // Desktop
        '(min-width: 1280px)': () => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: '.demo-animate',
              start: `center center+=5%`,
              scrub: true,
              end: `+=12000`,
              pin: true,
              anticipatePin: 1,
              markers: false,
              // onToggle: () => {},
              // onLeave: () => {},
              onUpdate: (self) => {
                let setIndex = Math.round(self.progress * 8)
                this.demoIndex = setIndex;
                // console.log('ScrollTrigger', setIndex);

                if (setIndex >= 1) {
                  this.showAiChip = true;
                } else {
                  this.showAiChip = false;
                }
              }
            },
            ease: 'Linear.easeNone'
          })

          tl.to('.progress-line', {
            strokeDashoffset: 1000,
          }, 'step2');
        },

        // Tablet
        '(min-width: 731px) and (max-width: 1279px)': () => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: '.demo-animate',
              start: `center center+=1%`,
              scrub: true,
              end: `+=9000`,
              pin: true,
              anticipatePin: 1,
              markers: false,
              // onToggle: () => {},
              // onLeave: () => {},
              onUpdate: (self) => {
                let setIndex = Math.round(self.progress * 8)
                this.demoIndex = setIndex;
                // console.log('ScrollTrigger', setIndex);

                if (setIndex >= 1) {
                  this.showAiChip = true;
                } else {
                  this.showAiChip = false;
                }
              }
            },
            ease: 'Linear.easeNone'
          })

          tl.to('.progress-line', {
            strokeDashoffset: 1000,
          }, 'step2');
        },

        // Mobile
        '(min-width: 0px) and (max-width: 730px)': () => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: '.demo-animate',
              start: `center center+=7%`,
              scrub: true,
              end: `+=8000`,
              pin: true,
              anticipatePin: 1,
              markers: false,
              // onToggle: () => {},
              // onLeave: () => {},
              onUpdate: (self) => {
                let setIndex = Math.round(self.progress * 8)
                this.demoIndex = setIndex;
                // console.log('ScrollTrigger', setIndex);
                this.$refs.mySwiper.swiper.slideTo(this.demoIndex - 1, 350, false);

                if (setIndex >= 1) {
                  this.showAiChip = true;
                } else {
                  this.showAiChip = false;
                }

                if (setIndex >= 6) {
                  this.mobileFeatureTip = '抗癌衛教';
                } else {
                  this.mobileFeatureTip = '遠距照護功能';
                }
              }
            },
            ease: 'Linear.easeNone'
          })

          tl.to('.progress-line', {
            strokeDashoffset: 1000,
          }, 'step2');
        }
      });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      // authJwtToken: 'user/exportUserJwtToken',
      loginStatus: 'user/exportLoginStatus',
      loginHashCode: 'user/exportUserHashCode',
      loginProfile: 'user/exportUserProfile',
      loginEproActive: 'user/exportEproSetupActive',
      // stateFlowBarFixed: 'global/exportFlowBarFixed',
      // stateIndexBanner: 'global/exportIndexBanner',
    }),
  },

  watch: {
    rwdType() {
      ScrollTrigger.refresh();
    },
  }
};
</script>

<style module lang='scss'>
  @import '../../sass/component/page/index.scss';
</style>
